import * as THREE from "three";
import loadingManager from "./loader.js";

export default function materials(scene){
    const textureLoader = new THREE.TextureLoader(loadingManager)

    const ColorTextureDotMarble = textureLoader.load('./textures/DotMarble/oak_veneer_01_diff_1k-3.jpg')
    const ARMTextureDotMarble = textureLoader.load('./textures/DotMarble/oak_veneer_01_rough_1k-3.png')
    ColorTextureDotMarble.colorSpace = THREE.SRGBColorSpace
    const materialDotMarble =     new THREE.MeshStandardMaterial({
        map: ColorTextureDotMarble,
        roughnessMap: ARMTextureDotMarble,
        metalnessMap: ARMTextureDotMarble,
    })
    ColorTextureDotMarble.wrapT = THREE.RepeatWrapping
    materialDotMarble.metalness = 0.3
    materialDotMarble.roughness = 0.2


    const ColorTextureWood = textureLoader.load('./textures/Wood/oak_veneer_01_diff_1k.jpg')
    const ARMTextureWood = textureLoader.load('./textures/Wood/oak_veneer_01_rough_1k.png')
    ColorTextureWood.colorSpace = THREE.SRGBColorSpace
    ColorTextureWood.wrapT = THREE.RepeatWrapping
    const materialWood =     new THREE.MeshStandardMaterial({
        map: ColorTextureWood,
        roughnessMap: ARMTextureWood,
        metalnessMap: ARMTextureWood,
    })
    materialWood.metalness = 0.3
    materialWood.roughness = 0.2

    const ColorTextureDarkMarble = textureLoader.load('./textures/DarkMarble/oak_veneer_01_diff_1k-2.jpg')
    const ARMTextureDarkMarble = textureLoader.load('./textures/DarkMarble/oak_veneer_01_rough_1k-3.png')
    ColorTextureDarkMarble.colorSpace = THREE.SRGBColorSpace
    ColorTextureDarkMarble.wrapT = THREE.RepeatWrapping
    const materialDarkMarble =     new THREE.MeshStandardMaterial({
        map: ColorTextureDarkMarble,
        roughnessMap: ARMTextureDarkMarble,
        metalnessMap: ARMTextureDarkMarble,
    })
    materialDarkMarble.metalness = 0.3
    materialDarkMarble.roughness = 0.2


    const materialArray = [materialDotMarble, materialWood, materialDarkMarble]

    const tempGeo = new THREE.PlaneGeometry(0.001, 0.001, )

    function warmUpMaterials(materialArray){
        materialArray.forEach((item)=>{
            const tempMeshWood = new THREE.Mesh(tempGeo, item)
            tempMeshWood.visible = true
            scene.add(tempMeshWood)
        })
    }

    warmUpMaterials(materialArray)

    return {materialDotMarble, materialWood, materialDarkMarble}
}